import React, { useState, useEffect, useRef } from "react";
import Select from "react-dropdown-select";
import { Icon } from "../../_components";

export function TimelineSelect({
  options,
  value,
  onChange,
  clearable,
  labelField = "title",
  valueField = "_id",
}) {
  // console.log("-----Starting Value", value);
  const componentRef = useRef();
  const [chosenOption, setChosenOption] = useState();
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [searchVal, setSearchVal] = useState("");
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [itemIndex, setItemIndex] = useState(null);

  const NullValue = {
    [labelField]: "Select One",
    [valueField]: "",
  };
  // options = [...options, NullValue];
  const handleChange = (option) => {
    // console.log('Changing to ', option);
    setChosenOption(option);
    setDropdownOpen(false);
    setItemIndex(null);
    if (onChange) onChange(option[valueField]);
  };
  const handleSearchChange = (ev) => {
    // console.log('Search Val Changing', ev);
    const { value } = ev.target;
    setSearchVal(value);
  };

  const handleClear = () => {
    setSearchVal("");
    setChosenOption(undefined);
    setItemIndex(null);
    if (onChange) onChange("");
  };

  const toggleDropdown = (opened) => {
    // console.log('Toggle arg', opened);
    if (opened && typeof opened === "boolean") setDropdownOpen(opened);
    else setDropdownOpen(!isDropdownOpen);
  };

  const handleKeydown = (ev) => {
    // console.log('Keydown', ev);
    if (ev.key === "ArrowDown") {
      ev.preventDefault();
      if (itemIndex === null) {
        setItemIndex(0);
      } else {
        if (itemIndex + 1 >= filteredOptions.length) {
          setItemIndex(0);
        } else {
          setItemIndex(itemIndex + 1);
        }
      }
      return;
    }
    if (ev.key === "ArrowUp") {
      ev.preventDefault();
      if (itemIndex === null) {
        setItemIndex(filteredOptions.length - 1);
      } else {
        if (itemIndex - 1 < 0) {
          setItemIndex(filteredOptions.length - 1);
        } else {
          setItemIndex(itemIndex - 1);
        }
      }
      return;
    }
    if (ev.key === "Enter") {
      ev.preventDefault();
      if (itemIndex && itemIndex !== null) {
        handleChange(filteredOptions[itemIndex]);
      }
    }
    return;
  };

  useEffect(() => {
    const handleOutsideClick = (ev) => {
      if (componentRef.current && !componentRef.current.contains(ev.target)) {
        setDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      window.addEventListener("click", handleOutsideClick);
    }

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [isDropdownOpen]);
  useEffect(() => {
    let newFilteredOptions = options.filter((option) => {
      return (
        option[labelField].toLowerCase().indexOf(searchVal.toLowerCase()) > -1
      );
    });
    setFilteredOptions(newFilteredOptions);
  }, [searchVal]);

  useEffect(() => {
    if (value && value !== "") {
      let defaultValue =
        (options && options.find((o) => o[valueField] === value)) || NullValue;
      setChosenOption(defaultValue);
    }
  }, []);
  return (
    <div className="chronos-select-component" ref={componentRef}>
      <div className="chronos-select-main" onClick={toggleDropdown}>
        <div className="chronos-select-display">
          {!chosenOption && (
            <TimelineSearch
              value={searchVal}
              update={handleSearchChange}
              opened={isDropdownOpen}
              toggleDropdown={toggleDropdown}
              onKeyNav={handleKeydown}
            />
          )}
          {chosenOption && (
            <TimelineSelectValue
              option={chosenOption}
              labelField={labelField}
            />
          )}
        </div>
        <div className="chronos-select-options">
          {clearable && chosenOption && (
            <Icon icon="far fa-times fa-fw" onClick={handleClear} />
          )}
          <Icon icon="far fa-chevron-down fa-fw" onClick={toggleDropdown} />
        </div>
      </div>
      {isDropdownOpen && (
        <TimelineDropdown
          options={filteredOptions}
          update={handleChange}
          activeKey={itemIndex}
          labelField={labelField}
        />
      )}
    </div>
  );
}

function TimelineOption({ item, update, active, labelField = "name" }) {
  const handleClick = () => {
    if (update) update(item);
  };
  return (
    <div
      className={"chronos-select-item" + (active ? " active" : "")}
      onClick={handleClick}
      key={item._id}
    >
      {/* {item.icon && <Icon icon={item.icon} />} */}
      <span className="chronos-select-item-text">{item[labelField]}</span>
    </div>
  );
}

function TimelineSelectValue({ option, labelField = "name" }) {
  return (
    <div className="chronos-select-chosen-value">
      {/* <Icon icon={option.icon} /> */}
      <span className="chronos-select-chosen-value-text">
        {option[labelField]}
      </span>
    </div>
  );
}

function TimelineSearch({ value, update, toggleDropdown, opened, onKeyNav }) {
  const handleSearchChange = (ev) => {
    if (update) update(ev);
  };
  const handleClick = (ev) => {
    if (ev.target === document.activeElement) {
      if (!opened) {
        toggleDropdown(true);
      }
    }
  };
  return (
    <input
      type="text"
      className="chronos-select-search"
      value={value}
      onChange={handleSearchChange}
      onClick={handleClick}
      onKeyDown={onKeyNav}
      placeholder="Search Event Types"
    />
  );
}

function TimelineDropdown({ options, update, activeKey, labelField = "name" }) {
  const handleOptionClick = (option) => {
    console.log("Dropdown option clicked", option);
    update(option);
  };
  return (
    <div className="chronos-select-dropdown">
      {options.map((option, i) => {
        return (
          <TimelineOption
            item={option}
            key={i}
            update={handleOptionClick}
            active={activeKey === i}
            labelField={labelField}
          />
        );
      })}
    </div>
  );
}
